@let notSet = defaultOrgNotSet();

<div class="modal-header">
  <h3 class="modal-title" i18n>Organizations</h3>
  @if (!notSet && !showOnlyAccessibleOrgs()) {
    <button
      (click)="activeModal.close()"
      aria-label="Close"
      class="btn-close"
      i18n-aria-label
      type="button"
    ></button>
  }
</div>

<div class="modal-body p-0">
  @if (!notSet && sharedService.env.name !== 'prod') {
    <div class="alert alert-info m-0 rounded-0 text-center">
      <p class="text-dark" i18n>
        <button (click)="deleteDefaultOrgId()" class="btn btn-link p-1">Delete default org</button>
        to simulate no defaultOrgId being set condition.<br />(You see this only on QA/localhost).
      </p>
    </div>
  }
  @if (notSet) {
    <div class="alert alert-danger m-0 rounded-0 text-center">
      <p class="text-dark fw-bold" i18n>Please set an organization as your default.</p>
    </div>
  }
  @if (orgsToDisplay().length > 5) {
    <div class="m-2">
      <cds-search-input
        [autofocus]="true"
        [formControl]="search"
        placeholder="Search for an organization by name or ID"
        inputClass="p-2 bg-grayscale6 shadow-sm safari-fix"
        i18n-placeholder
      ></cds-search-input>
    </div>
  }
  <cdk-virtual-scroll-viewport itemSize="64" style="height: calc(100vh - 200px)">
    <table class="table">
      <tbody>
        <tr *cdkVirtualFor="let org of filteredOrgs(); trackBy: trackById">
          <td class="d-flex align-items-center px-4">
            <div class="flex-grow-1">
              @if (notSet) {
                {{ org.name }}
              } @else {
                <button class="btn btn-link text-start" (click)="switchOrg(org)">
                  {{ org.name }}
                </button>
              }
              <span
                class="badge rounded-pill bg-light text-dark fw-light mx-2 border"
                i18n-ngbTooltip
                ngbTooltip="Org ID"
                >{{ org.id }}</span
              >
            </div>
            @if (!showOnlyAccessibleOrgs()) {
              @let isDefaultOrg = userState.user()?.defaultOrgId === org.id;
              <div>
                <span
                  [ngbTooltip]="isDefaultOrg ? 'The Organization that you\'ve set as default' : ''"
                >
                  <button
                    (click)="setDefaultOrg(org.id)"
                    [disabled]="isDefaultOrg"
                    class="btn btn-secondary no-text-wrap py-1"
                    i18n
                    type="button"
                  >
                    Set as default
                  </button>
                </span>
              </div>
            }
          </td>
        </tr>
      </tbody>
    </table>
  </cdk-virtual-scroll-viewport>
</div>
